<div class="content" [formGroup]="form">
  <div class="control-container">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.LABEL_TYPE' | translate }}
      </glxy-label>
      <mat-select [formControl]="notificationIdControl" required="true">
        <mat-option [value]="genericNotificationID">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.GENERIC' | translate }}
        </mat-option>
        <mat-option [value]="highPriorityNotificationID">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.HIGH_PRIORITY' | translate }}
        </mat-option>
        <mat-option [value]="shoppingCartAbandonedNotificationID">
          {{
            'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.ABANDONED_SHOPPING_CART'
              | translate
          }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
    <mat-hint class="external-hint">
      <automata-notifications-settings-link></automata-notifications-settings-link>
    </mat-hint>
  </div>
  <ng-container *ngIf="notificationIdControl.value !== shoppingCartAbandonedNotificationID; else shoppingCartAbandoned">
    <automata-send-notification-form
      #notificationForm
      [partnerId]="automation.namespace"
      [step]="step"
      [defaultLinkTemplate]="defaultLinkTemplate"
      [userTypeKey]="'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.USERS'"
      [notificationId]="notificationIdControl.value || ''"
    ></automata-send-notification-form>
  </ng-container>
  <ng-template #shoppingCartAbandoned>
    <mat-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.ABANDONED_SHOPPING_CART_HELP_TEXT' | translate }}
    </mat-label>
  </ng-template>
</div>
